"use client"

import type { CompanyListProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const CompanyList: ComponentConfig<CompanyListProps> = {
  label: "Tamda One | Company List",
  fields: {
    title: {
      label: "Title",
      type: "text",
      placeholder: "CÔNG TY THÀNH VIÊN",
    },
    titleFontSize: {
      label: "Title Font Size (px)",
      type: "number",
      min: 0,
      description: "Font size cho title (ví dụ: 24 cho text-2xl)",
    },
    titleFontWeight: {
      label: "Title Font Weight",
      type: "number",
      min: 0,
      max: 900,
      step: 100,
      description:
        "Font weight cho title (100-900, ví dụ: 800 cho font-extrabold). Nhập 100, 200, 300, 400, 500, 600, 700, 800, hoặc 900",
    },
    titleLineHeight: {
      label: "Title Line Height (px)",
      type: "number",
      min: 0,
      description: "Line height cho title (ví dụ: 37 cho 2.3125rem)",
    },
    gap: {
      label: "Gap between items (px)",
      type: "number",
      min: 0,
    },
    maxWidth: {
      label: "Max width (px)",
      type: "number",
      min: 0,
      description:
        "Max width cho container desktop. Để trống để dùng giá trị mặc định, hoặc nhập giá trị tùy chỉnh để giới hạn độ rộng tối đa của container",
    },
    companies: {
      label: "Companies",
      type: "array",
      getItemSummary: (item: any, index = 0) => item?.companyName || `Company ${index + 1}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: (props: any) => <ImageUploadField {...props} />,
        },
        companyName: {
          label: "Company Name",
          type: "text",
        },
        link: {
          label: "Link",
          type: "text",
        },
        width: {
          label: "Width (px)",
          type: "number",
          min: 0,
        },
        height: {
          label: "Height (px)",
          type: "number",
          min: 0,
        },
        paddingTop: {
          label: "Padding Top (px)",
          type: "number",
          min: 0,
        },
        paddingRight: {
          label: "Padding Right (px)",
          type: "number",
          min: 0,
        },
        paddingBottom: {
          label: "Padding Bottom (px)",
          type: "number",
          min: 0,
        },
        paddingLeft: {
          label: "Padding Left (px)",
          type: "number",
          min: 0,
        },
      },
      defaultItemProps: {
        image: "",
        companyName: "",
        width: undefined,
        height: undefined,
        link: "",
        paddingTop: undefined,
        paddingRight: undefined,
        paddingBottom: undefined,
        paddingLeft: undefined,
      },
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    title: "CÔNG TY THÀNH VIÊN",
    companies: [],
    gap: 32,
    maxWidth: undefined,
    titleFontSize: undefined,
    titleFontWeight: undefined,
    titleLineHeight: undefined,
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
}

export type { CompanyItem, CompanyListProps } from "@/types/types"
